var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 110,
    viewBox: "0 0 113 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 68.6367,
    r: 36.5,
    fill: "#D4DBFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 68.6367,
    r: 36.5,
    fill: "url(#paint0_radial)",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9417 72.2683C32.6666 72.7026 31.9366 74.0887 32.4356 75.3454C35.411 82.8856 44.1433 89.2338 54.391 89.2338C64.6387 89.2338 73.371 82.8856 76.3464 75.3454C76.8362 74.0887 76.1154 72.7026 74.8402 72.2683C62.4857 68.0916 46.2963 68.0916 33.9417 72.2683Z",
    fill: "#4C1DA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8289 61.0601C81.2355 61.3189 81.7899 61.0232 81.7899 60.5334V60.5242C81.7899 57.6042 79.4243 55.2386 76.5043 55.2386C73.5843 55.2386 71.2188 57.6042 71.2188 60.5242V60.5334C71.2188 61.0232 71.7639 61.3096 72.1798 61.0601C73.4365 60.2839 74.9149 59.8311 76.5043 59.8311C78.0937 59.8311 79.5722 60.2839 80.8289 61.0601Z",
    fill: "#4C1DA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 61.0598C37.0103 61.3185 37.5555 61.0228 37.5555 60.5331V60.5239C37.5555 57.6039 35.1899 55.2383 32.2699 55.2383C29.3499 55.2383 26.9844 57.6039 26.9844 60.5239V60.5331C26.9844 61.0228 27.5296 61.3093 27.9454 61.0598C29.2021 60.2836 30.6806 59.8308 32.2607 59.8308C33.8593 59.8308 35.3378 60.2836 36.5945 61.0598Z",
    fill: "#4C1DA1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8691 11.9189L32.7871 15.8369L36.7016 11.918L32.7836 7.99998L28.8691 11.9189Z",
    fill: "#6020D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39.9189L100.918 43.8369L104.832 39.918L100.914 36L97 39.9189Z",
    fill: "#6020D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77097 47.7066L8.57031 44.9375L5.79941 40.1413L1.00007 42.9104L3.77097 47.7066Z",
    fill: "#7E49DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.771 75.7017L108.57 72.9326L105.799 68.1364L101 70.9055L103.771 75.7017Z",
    fill: "#7E49DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0001 15.547L76.5449 23.0918L84.083 15.5452L76.5382 8.00037L69.0001 15.547Z",
    fill: "#7E49DD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.0625 61.8983) rotate(96.0235) scale(43.4785 43.4639)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854067,
    stopColor: "#D354FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#FFDA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854267,
    stopColor: "#783CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#783CE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/Smile.6932c6e89579f1ac23b3190e1abbdbf6.svg";
export { ForwardRef as ReactComponent };